<template>
  <section class="content">
    
    <div class="box box-info">
      <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <!--          <label>Item Upload</label>-->
          <!--          <Button label="Cancel" class="p-button-raised p-button-rounded" v-if="this.deliveryEntry != undefined"-->
          <!--                  @click="goBack()">Cancel-->
          <!--          </Button>-->
          <label for="accountUpload">Sms Excel Upload </label>
          <InputText id="accountUpload" type="file" @change="onFileSelect" multiple/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <a style="font-size: 18px" download="smsFormat.xlsx"
             href="../../../../static/excelFormat/smsFormat.xlsx">Click here to Download Format</a>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <Button class="p-button-raised p-button-rounded" label="Upload" @click.prevent="uploadExcel"></Button>
        </div>

      </div>
       
    </div>
  </section>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'

export default {
  name: 'excelUpload',
  data() {
    return {
      customerName: '',
      loading: false,
      id: null,
      images: []
    }
  },
  methods: {
    async uploadExcel() {
      let response = ''
      let excelUpload = {
        customerName: 'ssss'
      }
      const formData = new FormData()
      formData.append('excelUpload', JSON.stringify(excelUpload))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('uploadSmsExcelFormat', formData)
      this.loading = false
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        this.images.push(f)
      //   let reader = new FileReader()
      //   reader.onload = (e) => {
      //     this.url.push(e.target.result)
      //   }
      //   reader.readAsDataURL(f)
      })
    },
    reset() {
      this.customerName = ''
      this.images = []
      this.loading = false
    }
  },
  components: {
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css"/>



// WEBPACK FOOTER //
// sendSms.vue?5a4fabaf